import { combineReducers } from "redux";
import authReducer from "../layouts/Auth/redux/reducer";
import addressReducer from "../layouts/Admin/Address/redux/reducer";
import homeReducer from "../layouts/Admin/Home/redux/reducer";
import adminSetupReducer from "../layouts/Admin/Setup/redux/reducer";
import adminReportReducer from "../layouts/Admin/ReportAndEnquiry/redux/reducer";
import salesManagementReducer from "../layouts/Sales/Management/redux/reducer";
import purchaseManagementReducer from "../layouts/Purchase/Management/redux/reducer";
import salesTransactionsReducer from "../layouts/Sales/Transactions/redux/reducer";
import purchaseTransactionsReducer from "../layouts/Purchase/Transactions/redux/reducer";
import salesSettlementReducer from "../layouts/Sales/ReportAndEnquiry/redux/reducer";
import purchaseSettlementReducer from "../layouts/Purchase/ReportAndEnquiry/redux/reducer";
import salesSetupReducer from "../layouts/Sales/Setup/redux/reducer";
import purchaseSetupReducer from "../layouts/Purchase/Setup/redux/reducer";
import productSetupReducer from "../layouts/Product/Setup/redux/reducer";
import productProductReducer from "../layouts/Product/Product/redux/reducer";
import crudReducer from "../layouts/CRUD/redux/reducer";
import uploadReducer from "../layouts/Upload/redux/reducer";
import commonReducer from "../layouts/Dashboard/redux/reducer";
import younoteAdminSecuritySetupReducer from "../layouts/YounoteAdmin/SecuritySetup/redux/reducer";
import younoteAdminProductReducer from "../layouts/YounoteAdmin/Product/redux/reducer";
import salesDashboardReducer from "../layouts/Sales/Dashboard/redux/reducer";
import productDashboardReducer from "../layouts/Product/Dashboard/redux/reducer";
import purchaseDashboardReducer from "../layouts/Purchase/Dashboard/redux/reducer";
import adminDashboardReducer from "../layouts/Admin/Dashboard/redux/reducer";
import younoteAdminDashboardReducer from "../layouts/YounoteAdmin/Dashboard/redux/reducer";
import younoteAdminSetupReducer from "../layouts/YounoteAdmin/Setup/redux/reducer";
import scheduleInstanceReducer from "../layouts/Admin/BatchProcess/redux/reducer";

export const rootReducer = combineReducers({
    authReducer,
    addressReducer,
    homeReducer,
    adminSetupReducer,
    salesSetupReducer,
    purchaseSetupReducer,
    crudReducer,
    uploadReducer,
    productSetupReducer,
    productProductReducer,
    salesManagementReducer,
    purchaseManagementReducer,
    salesTransactionsReducer,
    purchaseTransactionsReducer,
    salesSettlementReducer,
    purchaseSettlementReducer,
    adminReportReducer,
    younoteAdminSecuritySetupReducer,
    younoteAdminProductReducer,
    salesDashboardReducer,
    purchaseDashboardReducer,
    adminDashboardReducer,
    younoteAdminDashboardReducer,
    productDashboardReducer,
    younoteAdminSetupReducer,
    commonReducer,
    scheduleInstanceReducer
});